import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { CartProvider } from "@/contexts/CartContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Store from "@/pages/Store";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Quotes from "@/pages/Quotes";
import QuoteBuilder from "@/pages/QuoteBuilder";
import Leads from "@/pages/Leads";
import Orders from "@/pages/Orders";
import AdminUsers from "@/pages/AdminUsers";
import AdminPartners from "@/pages/AdminPartners";
import AdminProducts from "@/pages/AdminProducts";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Handle OAuth callback synchronously to prevent race conditions
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  const wrap = (el) => <ProtectedRoute><Layout>{el}</Layout></ProtectedRoute>;
  const adminOnly = (el, roles) => <ProtectedRoute roles={roles}><Layout>{el}</Layout></ProtectedRoute>;

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />

      <Route path="/dashboard" element={wrap(<Dashboard />)} />
      <Route path="/store" element={wrap(<Store />)} />
      <Route path="/cart" element={wrap(<Cart />)} />
      <Route path="/checkout/success" element={wrap(<CheckoutSuccess />)} />
      <Route path="/quotes" element={wrap(<Quotes />)} />
      <Route path="/quotes/new" element={wrap(<QuoteBuilder />)} />
      <Route path="/leads" element={wrap(<Leads />)} />
      <Route path="/orders" element={wrap(<Orders />)} />

      <Route path="/admin/users" element={adminOnly(<AdminUsers />, ["super_user", "partner_success_manager", "partner_manager"])} />
      <Route path="/admin/partners" element={adminOnly(<AdminPartners />, ["super_user", "partner_success_manager"])} />
      <Route path="/admin/products" element={adminOnly(<AdminProducts />, ["super_user"])} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppRouter />
            <Toaster richColors position="top-right" />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
